import axios from 'axios';
import { AuthService } from '../../service/auth.service';
// Background health polling must not log an administrator out on a transient
// network error or create a global toast every ten seconds.
const client = axios.create({ baseURL: process.env.REACT_APP_API_URL, timeout: 8000 });
client.interceptors.request.use(config => {
  const token = AuthService.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export interface MonitoredNode {
  id: number; name: string; host: string; port: number; enabled: boolean;
  status: 'unknown' | 'up' | 'down'; checked_at: string | null; changed_at: string;
  latency_ms: number | null; error: string | null;
}
export interface NodeSnapshot { nodes: MonitoredNode[]; muted: boolean; canManage: boolean; serverTime: string; staleAfterSeconds: number; telegram?: { configured: boolean; hasChat: boolean; lastStatus: string | null; lastError: string | null } }
export const loadNodes = async (): Promise<NodeSnapshot> => (await client.get('system/nodes')).data;
export const loadNodeAdmins = async () => (await client.get('system/nodes/admins')).data;
export const saveNode = (node: { id?: number; name: string; host: string; enabled: boolean }) => client.post('system/nodes', node);
export const setNodeMute = (muted: boolean, userId?: number) => client.post('system/nodes/preference', { muted, userId });
export const removeNode = (id: number) => client.delete(`system/nodes/${id}`);
export const testNodeTelegram = async (): Promise<{ status: string; error: string | null }> => (await client.post('system/nodes/test')).data;
export const nodeIsStale = (node: MonitoredNode, snapshot: NodeSnapshot) => node.enabled &&
  (!node.checked_at || Date.parse(snapshot.serverTime) - Date.parse(node.checked_at) > snapshot.staleAfterSeconds * 1000);
